exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-time-log-wrapper[data-v-7975364c]{background-color:#005086}.add-time-log-wrapper[data-v-7975364c],.remove-input-wrapper[data-v-7975364c]{min-height:24px;min-width:24px;max-height:24px;max-width:24px;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-items:center;color:#fff;margin-left:8px;cursor:pointer}.remove-input-wrapper[data-v-7975364c]{background-color:red}", ""]);

// exports
